<template>
  <div>
    <div class="modal fade" id="table-config">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true"> &times; </span>
            </button>
            <h4 class="modal-title">Configurar Listado</h4>
          </div>
          <div class="modal-body">
            <div class="col-xs-12 col-lg-6">
              <div class="checkbox check-default">
                <input
                  type="checkbox"
                  checked="checked"
                  v-model="visibleColumns"
                  value="id"
                />
                <label for="checkbox1">ID</label>
              </div>
              <div class="checkbox check-default">
                <input
                  type="checkbox"
                  checked="checked"
                  v-model="visibleColumns"
                  value="legal_name"
                />
                <label for="checkbox1">Nombre Legal</label>
              </div>
              <div class="checkbox check-default">
                <input
                  type="checkbox"
                  checked="checked"
                  v-model="visibleColumns"
                  value="name"
                />
                <label for="checkbox1">Nombre</label>
              </div>
              <div class="checkbox check-default">
                <input
                  type="checkbox"
                  checked="checked"
                  v-model="visibleColumns"
                  value="email"
                />
                <label for="checkbox2">Email</label>
              </div>
              <div class="checkbox check-default">
                <input
                  type="checkbox"
                  checked="checked"
                  v-model="visibleColumns"
                  value="phone"
                />
                <label for="checkbox2">Telefono</label>
              </div>
              <div class="checkbox check-default">
                <input
                  type="checkbox"
                  checked="checked"
                  v-model="visibleColumns"
                  value="shop.retention"
                />
                <label for="checkbox2">Comision</label>
              </div>
              <div class="checkbox check-default">
                <input
                  type="checkbox"
                  checked="checked"
                  v-model="visibleColumns"
                  value="ProviderRepresentative.name"
                />
                <label for="checkbox2">Representante</label>
              </div>
              <div class="checkbox check-default">
                <input
                  type="checkbox"
                  checked="checked"
                  v-model="visibleColumns"
                  value="ProviderRepresentative.phone"
                />
                <label for="checkbox2">Telefono Representante</label>
              </div>
            </div>
            <div class="col-xs-12 col-lg-6">
              <!-- <div class="checkbox check-default">
                            <input type="checkbox" checked="checked" v-model="visibleColumns" value="offersStatus">
                            <label for="checkbox8">Estado de oferta</label>
                        </div> -->
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="modal-footer text-center">
            <div class="row">
              <div class="col-md-12">
                <a data-dismiss="modal" class="btn btn-bgrey">CANCELAR</a>
                <a data-dismiss="modal" class="btn btn-success">APLICAR</a>
              </div>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- FOOTER   -->
    <footer class="footer b-t b-grey">
      <div class="copyright">
        2016 &copy; Cash Depot - Todos los derechos reservados.
      </div>
    </footer>
    <!-- OLD DIV VERSION    <div class="col-md-10 col-sm-9 col-md-offset-2 col-sm-offset-3 content container-fluid">-->
    <div class="col-xs-12 content container-fluid">
      <div class="wrapper">
        <div class="container-wrapper">
          <div id="alerts-container"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <a
            :disabled="loadingTable"
            class="btn btn-default pull-right"
            href="/#!/create-provider"
          >
            <span class="glyphicon glyphicon-plus"> </span> Crear Proveedor
          </a>
        </div>
      </div>
      <div id="app" class="ui vertical stripe segment">
        <div class="col-xs-12 m-t-20">
          <div
            class="input-group transparent col-xs-12 col-lg-6 p-r-5 m-b-20 pull-left"
          >
            <input
              :disabled="loadingTable"
              type="text"
              class="form-control f-text-md"
              v-model="filterText"
              @keypress.enter="getProviders()"
              placeholder="Buscar: proveedor"
              id="search-btn"
              name="search-btn"
            />
            <span class="input-group-addon bg-white">
              <i
                :disabled="loadingTable"
                @click="getProviders()"
                class="md md-search sm-ico"
              >
              </i>
            </span>
          </div>
          <button
            class="btn btn-default download-table-btn"
            :disabled="loadingTable"
            @click="exportTable()"
          >
            <span class="glyphicon glyphicon-download-alt"></span>
            DESCARGAR
          </button>
          <button
            class="btn btn-default download-table-btn"
            :disabled="loadingTable"
            data-toggle="modal"
            data-target="#table-config"
          >
            <span class="glyphicon glyphicon-cog"></span> CONFIGURACiÓN
          </button>
          <button
            v-show="false"
            class="btn btn-primary dropdown-toggle m-l-5"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            id="dropdownfilter"
          >
            <i class="md md-tune sm-ico b-r b-white p-r-20 m-r-20"></i> FILTRAR
          </button>
        </div>
        <div class="row">
          <div class="col-xs-12 m-t-20">
            <div class="table-responsive">
              <div id="content" class="ui basic segment">
                <table
                  id="table-with-sorting"
                  class="table data-table with-sorting table-striped tablesorter payment-batch-table sortable"
                >
                  <thead>
                    <tr>
                      <th style="width: 40px"></th>
                      <th v-show="showElement('id')">
                        <span @click="sort('id', false)">
                          Id
                          <span
                            v-show="sortBy == 'id'"
                            :class="getSortIcon()"
                          ></span>
                        </span>
                      </th>
                      <th v-show="showElement('legal_name')">Nombre Legal</th>
                      <th v-show="showElement('name')">Nombre</th>
                      <th v-show="showElement('email')">Email</th>
                      <th v-show="showElement('phone')">Telefono</th>
                      <th v-show="showElement('shop.retention')">Comision</th>
                      <th v-show="showElement('ProviderRepresentative.name')">
                        Representante
                      </th>
                      <th v-show="showElement('ProviderRepresentative.phone')">
                        Telefono Representante
                      </th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody v-if="!loadingTable">
                    <tr v-for="provider in providers">
                      <td>
                        <input
                          :value="provider"
                          v-model="checkedProvider"
                          type="checkbox"
                        />
                      </td>
                      <td v-show="showElement('id')">
                        {{ provider.id }}
                      </td>
                      <td v-show="showElement('legal_name')">
                        {{ provider.legal_name }}
                      </td>
                      <td v-show="showElement('name')">
                        <a href="/#!/administrator/provider/{{provider.id}}">{{
                          provider.name
                        }}</a>
                      </td>
                      <td v-show="showElement('email')">
                        {{ provider.email }}
                      </td>
                      <td v-show="showElement('phone')">
                        {{ provider.phone }}
                      </td>
                      <td v-show="showElement('shop.retention')">
                        {{ provider.shop[0].retention }}
                      </td>
                      <td v-show="showElement('ProviderRepresentative.name')">
                        {{ provider.ProviderRepresentative.name }}
                      </td>
                      <td v-show="showElement('ProviderRepresentative.phone')">
                        {{ provider.ProviderRepresentative.phone }}
                      </td>
                      <td>
                        <a
                          @click="getInfo(provider)"
                          class="btn btn-success btn-xs"
                          >info</a
                        >
                      </td>
                    </tr>
                  </tbody>
                  <tfoot v-show="!loadingTable">
                    <tr>
                      <th colspan="12">
                        <div class="row">
                          <div class="col-xs-12">
                            <pagination
                              :total="total"
                              :page-size="pageSize"
                              :callback="pageChanged"
                              :options="paginationOptions"
                              nav-class="padding-10"
                              ul-class="bg-color-red"
                              li-class="txt-color-blue"
                            >
                            </pagination>
                          </div>
                        </div>
                      </th>
                    </tr>
                  </tfoot>
                </table>
                <template v-if="loadingTable">
                  <div style="text-align: center">
                    <span class="fa fa-spin fa-spinner"></span>
                  </div>
                </template>
              </div>
            </div>
            <!--</div>-->
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="provaiderModal" role="dialog">
      <div class="modal-dialog modal-opinion">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
            <h4 class="modal-title">{{ provider.name }}</h4>
          </div>
          <div class="modal-body">
            <table class="table table-striped">
              <tbody>
                <tr>
                  <td>Nombre Legal:</td>
                  <td>{{ provider.legal_name }}</td>
                </tr>
                <tr>
                  <td>Nombre:</td>
                  <td>{{ provider.name }}</td>
                </tr>
                <tr>
                  <td>Email:</td>
                  <td>{{ provider.email }}</td>
                </tr>
                <tr>
                  <td>Telefono:</td>
                  <td>{{ provider.phone }}</td>
                </tr>
                <tr>
                  <td>Comision:</td>
                  <td>{{ provider.shop[0].retention }}</td>
                </tr>
                <tr>
                  <td>Representante:</td>
                  <td>{{ provider.ProviderRepresentative.name }}</td>
                </tr>
                <tr>
                  <td>Telefono Representante:</td>
                  <td>{{ provider.ProviderRepresentative.phone }}</td>
                </tr>
                <tr>
                  <td>Usuario POS:</td>
                  <td>{{ provider.shop[0].nickname }}</td>
                </tr>
                <tr>
                  <td>Password POS:</td>
                  <td>{{ provider.shop[0].password }}</td>
                </tr>
                <tr>
                  <td>Cuenta Bancaria:</td>
                  <td>{{ provider.shop[0].account }}</td>
                </tr>
                <tr>
                  <td>Direccion:</td>
                  <td>{{ provider.address }}</td>
                </tr>
              </tbody>
            </table>
            <div class="clearfix"></div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn cancel-btn" data-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "../utilities/pagination.vue";
export default {
  data() {
    return {
      api_url: `http://api.cashdepotint.com/v1`,
      name: "",
      email: "",
      currentPage: 1,
      checkedProvider: [],
      filterText: "",
      startDate: "",
      due_date: "",
      validity: "",
      amount: 0,
      cost: 0,
      columnTitles: {
        id: "Id",
        title: "Nombre",
        description: "Email",
      },
      loadingTable: true,
      total: 1000,
      pageSize: 50,
      paginationOptions: {
        // Not required to pass this configurations
        offset: 1,
        previousText: "Anterior",
        nextText: "Siguiente",
        alwaysShowPrevNext: true,
      },
      providers: [],
      provider: {},
      selectedProvider: "",
      sortBy: "id",
      sortOrder: "DESC",
      moreParams: ["q=(is_deleted:0)"],
      visibleColumns: [],
      vid: false,
      selectedColumns: "",
      user_id: "",
    };
  },
  watch: {
    providers() {
      $(".popover").popover("hide");
      $("[data-toggle=popover]").popover({
        html: true,
        trigger: "manual",
        content: () => {
          $(".popover").popover("hide");
          return $("#popover-content").html();
        },
      });
    },
  },
  filters: {
    dateFormat: function (date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
  components: {
    Pagination,
  },
  created() {
    this.user_id = this.$route.query.id;

    if (!this.user_id) {
      this.user_id = window.localStorage.getItem("user_id");
    } else {
      window.localStorage.setItem("user_id", this.user_id);
    }

    this.getProviders();
  },
  methods: {
    getInfo: function (provider) {
      this.provider = provider;
      $("#provaiderModal").modal("toggle");
    },
    returnId: function (value) {
      return value;
    },
    sync: function (event, tipo) {
      event.preventDefault();
      this[tipo] = event.target.files[0] || event.dataTransfer.files[0];

      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      reader.onload = (event) => {
        vm.imageSrc = event.target.result;
      };

      reader.readAsDataURL(this[tipo]);
    },
    returnName: function (value) {
      return value;
    },

    returnEmail: function (value) {
      return value;
    },

    getProviders: function () {
      let params = "";
      if (this.filterText) {
        params = `,title:${this.filterText}%`;
      }
      this.$http
        .get(
          apiUrl +
            `/providers?relationships=shop,ProviderRepresentative&q=(is_deleted:0${params})&format=true&limit=100&page=${this.currentPage}&sort=${this.sortBy}|${this.sortOrder}`
        )
        .then(
          (response) => {
            this.providers = response.body.data;
            this.total = response.body.total_pages * 50;
            this.loadingTable = false;
          },
          (response) => {
            sweetAlert(
              "Oops...",
              "Ha ocurrido un error al cargar los proovedores !",
              "error"
            );
          }
        );
    },

    getSortIcon() {
      if (this.sortOrder == "ASC") {
        return "glyphicon glyphicon-chevron-up";
      }
      return "glyphicon glyphicon-chevron-down";
    },

    showElement(elementName) {
      return this.visibleColumns.includes(elementName);
    },

    /**
     * Prepares the data and exports the current page table or the selected offers
     */
    exportTable() {
      let temporaryOffersList = this.providers;
      let formattedOffersList = [];

      if (this.checkedProvider.length) {
        temporaryOffersList = this.checkedProvider;
      }

      for (let i = 0; i < temporaryOffersList.length; i++) {
        let temporaryContact = {};

        for (let j = 0; j < this.visibleColumns.length; j++) {
          let columnName = this.columnTitles[this.visibleColumns[j]];

          if (_.isObject(temporaryOffersList[i][this.visibleColumns[j]])) {
            if (columnName) {
              temporaryContact[columnName] =
                temporaryOffersList[i][this.visibleColumns[j]].name;
            } else {
              temporaryContact[this.visibleColumns[j]] =
                temporaryOffersList[i][this.visibleColumns[j]].name;
            }
          } else {
            if (columnName) {
              if (this.visibleColumns[j] == "validity") {
                let validity =
                  temporaryOffersList[i][this.visibleColumns[j]] == "0"
                    ? "Indefinida"
                    : "Temporal";
                temporaryContact[columnName] = validity;
              } else if (columnName.includes("Fecha")) {
                temporaryContact[columnName] = moment(
                  temporaryOffersList[i][this.visibleColumns[j]]
                ).format("DD/MM/YYYY");
              } else {
                temporaryContact[columnName] =
                  temporaryOffersList[i][this.visibleColumns[j]];
              }
            } else {
              temporaryContact[this.visibleColumns[j]] =
                temporaryOffersList[i][this.visibleColumns[j]];
            }
          }
        }

        formattedOffersList.push(temporaryContact);
      }

      this.JSONToCSVConvertor(
        formattedOffersList,
        `Listado de Ofertas - Página ${this.currentPage}`,
        true
      );
    },
    /**
     * Converts a JSON string to a CVS file (Excel readable file)
     *
     * @param      {string}  ReportTitle  The report title
     * @param      {boolean} ShowLabel    Flag that shows/hides the report title in the document
     */
    JSONToCSVConvertor(List, ReportTitle, ShowLabel) {
      let JSONData = JSON.stringify(List);

      //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
      var arrData =
        typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;

      var CSV = "";
      //Set Report title in first row or line

      CSV += ReportTitle + "\r\n\n";

      //This condition will generate the Label/Header
      if (ShowLabel) {
        var row = "";
        //This loop will extract the label from 1st index of on array
        for (var index in arrData[0]) {
          //Now convert each value to string and comma-seprated
          row += index + ",";
        }

        row = row.slice(0, -1);

        //append Label row with line break
        CSV += row + "\r\n";
      }

      //1st loop is to extract each row
      for (var i = 0; i < arrData.length; i++) {
        var row = "";

        //2nd loop will extract each column and convert it in string comma-seprated
        for (var index in arrData[i]) {
          row += '"' + arrData[i][index] + '",';
        }

        row.slice(0, row.length - 1);

        //add a line break after each row
        CSV += row + "\r\n";
      }

      if (CSV == "") {
        alert("Invalid data");
        return;
      }

      //Generate a file name
      var fileName = ReportTitle;

      //Initialize file format you want csv or xls
      var uri = "data:text/csv;charset=utf-8," + escape(CSV);

      // Now the little tricky part.
      // you can use either>> window.open(uri);
      // but this will not work in some browsers
      // or you will not get the correct file extension

      //this trick will generate a temp <a /> tag
      var link = document.createElement("a");
      link.href = uri;

      //set the visibility hidden so it will not effect on your web-layout
      link.style = "visibility:hidden";
      link.download = fileName + ".csv";

      //this part will append the anchor tag and remove it after automatic click
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    sort(selectedColumn, isString) {
      if (this.sortBy == selectedColumn && !isString) {
        if (this.sortOrder == "ASC") {
          this.sortOrder = "DESC";
        } else {
          this.sortOrder = "ASC";
        }
      } else if (this.sortBy == selectedColumn && isString) {
        if (this.sortOrder == "DESC") {
          this.sortOrder = "ASC";
        } else {
          this.sortOrder = "DESC";
        }
      } else if (this.sortBy !== selectedColumn && !isString) {
        this.sortOrder = "DESC";
      } else if (this.sortBy !== selectedColumn && isString) {
        this.sortOrder = "ASC";
      }

      this.sortBy = selectedColumn;
      this.getProviders();
    },
    pageChanged(page) {
      this.currentPage = page;
      this.getProviders();
      // Exec your response to server passing 'page' params as clicked button paging
    },
  },

  events: {
    "vuetable:action": function (action, data) {
      if (action == "view-item") {
        window.location.href = "/#!/offers/" + data.id + "/information";
      }
    },
    "vuetable:load-error": function (response) {
      console.log("Load Error: ", response);
    },
    "vuetable:loaded": function (response) {
      this.loadingTable = false;
    },
    "reload-table"() {
      this.getProviders();
    },
    "updated-offer"() {
      this.getProviders();
    },
  },
};
</script>

<style scoped>
.txt-blue {
  color: #0000ee;
}
</style>



// WEBPACK FOOTER //
// list.vue?5a44ba68